"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _draftExtend = require("draft-extend");

var _draftConvert = require("draft-convert");

var _AtMentionPlugin = _interopRequireDefault(require("draft-plugins/plugins/atmentions/AtMentionPlugin"));

var _draftJs = require("draft-js");

var _KeyCodes = require("UIComponents/constants/KeyCodes");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _userHelpers = require("composer-lib/lib/helpers/userHelpers");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var HANDLED = _constants.DRAFT_CANCELLABLE_HANDLERS.HANDLED,
    NOT_HANDLED = _constants.DRAFT_CANCELLABLE_HANDLERS.NOT_HANDLED;

var tokenToHTML = function tokenToHTML(_ref) {
  var text = _ref.text,
      value = _ref.value;
  return "<span data-token data-type=\"USER\" data-id=\"" + value + "\">" + text + "</span>";
};

var createCommentEditorConfig = function createCommentEditorConfig(_ref2) {
  var useInviteZeroState = _ref2.useInviteZeroState,
      validateZeroState = _ref2.validateZeroState,
      onDropdownOpen = _ref2.onDropdownOpen,
      onDropdownClose = _ref2.onDropdownClose,
      onInviteSuccess = _ref2.onInviteSuccess;
  return (0, _draftExtend.compose)((0, _AtMentionPlugin.default)({
    tokenClassName: 'editor-mention-token',
    onOpen: onDropdownOpen,
    onClose: onDropdownClose,
    useInviteZeroState: useInviteZeroState,
    inviteZeroStateOpts: {
      onInviteSuccess: onInviteSuccess,
      validate: validateZeroState,
      provisioning: {
        send_welcome_email: true,
        subscriptions: [],
        roleGroups: [{
          roles: [],
          type: 'global'
        }, {
          type: 'marketing',
          roles: ['contentCreator'],
          secondaryRoles: [{
            app: 'blog',
            type: 'write'
          }]
        }]
      }
    },
    tokenToHTML: tokenToHTML
  }));
};

var _default = (0, _createReactClass.default)({
  displayName: "CommentEditor",
  propTypes: {
    commentCount: _propTypes.default.number,
    externalMentionsEnabled: _propTypes.default.bool,
    postComment: _propTypes.default.func,
    refetchUsers: _propTypes.default.func,
    setClickToHideConversationsListener: _propTypes.default.func,
    users: _propTypes.default.object.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      editorState: _draftJs.EditorState.createEmpty(),
      dropdownOpen: false,
      editorFocused: true
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.buildEditor();
  },
  componentDidMount: function componentDidMount() {
    this._editor.focus();

    document.body.addEventListener('click', this.onBodyClicked);
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (!prevState.dropdownOpen && this.state.dropdownOpen) {
      this.props.setClickToHideConversationsListener(false);
    } else if (prevState.dropdownOpen && !this.state.dropdownOpen) {
      this.props.setClickToHideConversationsListener(true);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    document.body.removeEventListener('click', this.onBodyClicked);
  },
  onBodyClicked: function onBodyClicked(e) {
    // We want to keep focused state while user has at-mention dropdown open
    if (this.state.dropdownOpen) {
      return;
    }

    var containerEl = _reactDom.default.findDOMNode(this._container);

    if (containerEl && (containerEl === e.target || containerEl.contains(e.target))) {
      this.setState({
        editorFocused: true
      });
    } else {
      this.setState({
        editorFocused: false
      });
    }
  },
  buildEditor: function buildEditor() {
    var commentEditorConfig = createCommentEditorConfig({
      useInviteZeroState: this.props.externalMentionsEnabled,
      validateZeroState: this.validateZeroState,
      onDropdownOpen: this.onDropdownOpen,
      onDropdownClose: this.onDropdownClose,
      onInviteSuccess: this.onInviteSuccess
    });
    this.EditorWithPlugins = commentEditorConfig(_draftExtend.Editor);
    this.convertCommentToHTML = commentEditorConfig(_draftConvert.convertToHTML);
  },
  onChange: function onChange(editorState) {
    this.setState({
      editorState: editorState
    });
  },
  onDropdownOpen: function onDropdownOpen() {
    this.setState({
      dropdownOpen: true
    });
  },
  onDropdownClose: function onDropdownClose() {
    this.setState({
      dropdownOpen: false
    });
  },
  onInviteSuccess: function onInviteSuccess() {
    (0, _UsageTracking.trackEvent)({
      action: 'at-mention-external-user',
      name: _constants.AmplitudeEvents.COMPOSITION_COLLABORATION
    });
    this.props.refetchUsers();
  },
  keyBindingFn: function keyBindingFn(e) {
    if (e.keyCode === _KeyCodes.ENTER && _draftJs.KeyBindingUtil.hasCommandModifier(e)) {
      return this.handleSendButtonClick();
    }

    return (0, _draftJs.getDefaultKeyBinding)(e);
  },
  handlePastedText: function handlePastedText(plainText, __html, currentEditorState) {
    // override default behavior of processing pasted HTML and instead only process the
    // plain text -- we don't want to include e.g. bold tags from pasted content
    // when we submit comments because the endpoint doesn't like them
    var newContent = _draftJs.Modifier.insertText(currentEditorState.getCurrentContent(), currentEditorState.getSelection(), plainText);

    var newEditorState = _draftJs.EditorState.createWithContent(newContent);

    newEditorState = _draftJs.EditorState.moveFocusToEnd(newEditorState);
    this.onChange(newEditorState);
    return true;
  },
  handleSendButtonClick: function handleSendButtonClick() {
    var _this$state = this.state,
        dropdownOpen = _this$state.dropdownOpen,
        editorState = _this$state.editorState;
    var currentContent = editorState.getCurrentContent();

    if (dropdownOpen || !currentContent.getPlainText()) {
      return NOT_HANDLED;
    }

    var commentHTML = this.convertCommentToHTML(currentContent);
    var atMentions = commentHTML.match(/data-token/g);

    if (atMentions) {
      (0, _UsageTracking.trackEvent)({
        action: 'at-mention',
        name: _constants.AmplitudeEvents.COMPOSITION_COLLABORATION
      });
    }

    this.props.postComment(commentHTML);
    this.setState({
      editorState: _draftJs.EditorState.createEmpty()
    });
    return HANDLED;
  },
  validateZeroState: function validateZeroState(inviteeEmail) {
    var users = this.props.users;

    if (users.data.find(function (user) {
      return user.email === inviteeEmail;
    })) {
      return _I18n.default.text('composer-lib.conversations.mentions.failedInvite');
    }

    return null;
  },
  renderSendComment: function renderSendComment() {
    if (!this.state.editorFocused) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "send-comment text-right m-top-2"
    }, _react.default.createElement(_UIButton.default, {
      use: "primary",
      onClick: this.handleSendButtonClick,
      size: "small"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.conversations.sendComment"
    })));
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        commentCount = _this$props.commentCount,
        users = _this$props.users;
    var editorState = this.state.editorState;
    var EditorWithPlugins = this.EditorWithPlugins;
    return _react.default.createElement("div", {
      className: "comment-editor p-all-4",
      ref: function ref(c) {
        return _this._container = c;
      }
    }, _react.default.createElement(EditorWithPlugins, {
      editorState: editorState,
      handlePastedText: this.handlePastedText,
      keyBindingFn: this.keyBindingFn,
      onChange: this.onChange,
      placeholder: _I18n.default.text("composer-lib.conversations.placeholder." + (commentCount ? 'reply' : 'leaveComment')),
      users: (0, _userHelpers.packageUserDataForTokens)(users),
      ref: function ref(c) {
        return _this._editor = c;
      }
    }), this.renderSendComment());
  }
});

exports.default = _default;
module.exports = exports.default;